import { gql } from '@apollo/client'

export const personalDataMutation = gql`
  mutation personalDataMutation(
    $firstName: String!
    $lastName: String!
    $nickname: String
    $gender: String!
    $nationality: String!
    $contactLanguage: String!
    $placeOfOrigin: String!
    $socialInsuranceNumber: String
    $healthInsurance: String
    $residenceCategoryValidUntil: String
    $residenceCategoryZemisNumber: String
    $residenceCategoryType: String
  ) {
    personalData(
      personalData: {
        firstName: $firstName
        lastName: $lastName
        nickname: $nickname
        gender: $gender
        nationality: $nationality
        contactLanguage: $contactLanguage
        placeOfOrigin: $placeOfOrigin
        socialInsuranceNumber: $socialInsuranceNumber
        healthInsurance: $healthInsurance
        residenceCategoryValidUntil: $residenceCategoryValidUntil
        residenceCategoryZemisNumber: $residenceCategoryZemisNumber
        residenceCategoryType: $residenceCategoryType
      }
    ) {
      success
    }
  }
`
